import React from 'react';
import PropTypes from 'prop-types';
import { Box, Drawer, styled } from '@mui/material';
// ------------------------------------------------------------------
const Wrapper = styled(Box)(({ theme }) => ({
    top: 0,
    height: '100vh',
    width: 'inherit',
    position: 'fixed',
    overflow: 'hidden',
    overflowY: 'scroll',
    boxShadow: theme.shadows[1],
    zIndex: theme.zIndex.drawer + 3,
}));

const LayoutDrawer = (props) => {
    const { children, open, onClose, drawerWidth = 280 } = props;
    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: drawerWidth,
                },
            }}
        >
            <Wrapper>{children}</Wrapper>
        </Drawer>
    );
};
LayoutDrawer.propTypes = {
    children: PropTypes.any,
    open: PropTypes.any,
    onClose: PropTypes.any,
    drawerWidth: PropTypes.any,
};
export default LayoutDrawer;
